import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { authReducer } from './authSlice';


const persistConfig = {
    key: 'root',
    storage,
}

const rootReducer = combineReducers({
    auth: authReducer

});

const persistedReducer = persistReducer(persistConfig, rootReducer)



export const store = configureStore({
    // reducer: {
    //     cart: cartReducer,
    // },
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    // middleware: [thunk]
})


export const persistor = persistStore(store)
